/**
 * Count a visit to a page of the site, for its space's Usage tab (api/site-visit.js, migration
 * 20261205120000). A plain request, signed in or not: the site loads no Supabase client, and the
 * server keeps only a daily-salted hash of who asked.
 *
 * Once per page per half hour in this tab, so a reload or a back-and-forth is one visit; the server
 * applies the same half hour, so two tabs are one visit too. Never throws, never waits.
 */
const SEEN_KEY = 'arcos:site-visits';
const WINDOW_MS = 30 * 60 * 1000;

function readSeen() {
  try { return JSON.parse(sessionStorage.getItem(SEEN_KEY) || '{}') || {}; } catch { return {}; }
}

/** PURE. Whether `key` was counted within the window, and the map to store after counting it now. */
export function noteVisit(seen, key, now = Date.now()) {
  const fresh = Object.fromEntries(Object.entries(seen || {}).filter(([, at]) => now - at < WINDOW_MS));
  if (fresh[key]) return { skip: true, next: fresh };
  return { skip: false, next: { ...fresh, [key]: now } };
}

export function recordSiteVisit({ space, ref = null }) {
  if (!space || typeof window === 'undefined') return;
  try {
    const { skip, next } = noteVisit(readSeen(), `${space}|${ref || ''}`);
    if (skip) return;
    try { sessionStorage.setItem(SEEN_KEY, JSON.stringify(next)); } catch { /* storage may be blocked */ }
    const body = JSON.stringify({ space, ref });
    // sendBeacon survives the page being closed straight away; fetch with keepalive is the fallback.
    const sent = typeof navigator.sendBeacon === 'function'
      && navigator.sendBeacon('/api/site-visit', new Blob([body], { type: 'application/json' }));
    if (!sent) {
      fetch('/api/site-visit', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true })
        .catch(() => {});
    }
  } catch { /* a visit counter must never be what breaks a page */ }
}
